import { Route, Routes, useLocation } from "react-router-dom";
import { RouteProps, adminRoutes, nonAuthRoutes, routes } from "./routes";
import ThemeLayout from "../ThemeLayout";
import NonLayout from "ThemeLayout/NonLayout";
import { useEffect } from "react";
import { setUser } from "Slices/theme/reducer";
import { useDispatch } from "react-redux";

const Routing = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("userData") || "{}");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (user) {
      dispatch(setUser(user));
    }
  }, [location]);

  return (
    <>
      <Routes>
        {/* Non-Auth Routes */}
        {(nonAuthRoutes || []).map((item: RouteProps, key: number) => (
          <Route
            key={key}
            path={item.path}
            element={<NonLayout>{item.element}</NonLayout>}
          />
        ))}

        {/* Public Routes */}
        {(routes || []).map((item: RouteProps, key: number) => (
          <Route
            key={key}
            path={item.path}
            element={<ThemeLayout>{item.element}</ThemeLayout>}
          />
        ))}

        {/* Admin Routes (Nested) */}
        <Route path={adminRoutes.path} element={adminRoutes.element}>
          {/* Nested Admin Routes */}
          {adminRoutes.children?.map(({ path, element }, index) => (
            <Route key={index} path={path} element={element} />
          ))}
        </Route>

        {/* Billing Routes (Nested) */}
        {/* <Route path={billingRoutes.path} element={billingRoutes.element}>
          {billingRoutes.children?.map(({ path, element }, index) => (
            <Route key={index} path={path} element={element} />
          ))}
        </Route> */}
      </Routes>
    </>
  );
};

export default Routing;
